module.exports = __webpack_public_path__ + "static/media/cahrt-1.f33cb040.png";